import { useQuery } from '@tanstack/react-query';
import { fetchActiveContracts } from '../../api/contracts';

export const useActiveContracts = (options = {}) => {
  const query = useQuery({
    queryKey: ['contracts', 'active'],
    queryFn: () => fetchActiveContracts(),
    enabled: options.enabled !== false,
  });

  return {
    ...query,
    contracts: query.data?.data?.contracts ?? [],
  };
};

export default useActiveContracts;
